import  Aboutus from './Aboutus';
import  Cards from './Cards';
import  Footer from '../components/Footer';
import  Header from './Header';
import  Navbar from '../components/Navbar';
import  Testimonials from './Testimonials';
import whatsapp from './../images/whatsapp.svg'
import './styles.css'

function LandingPage(){
  return(
    <>
      <Navbar />
      <div>
      <a className="whatsapp" href="//api.whatsapp.com/send?phone=+919871013411"><img src={whatsapp} alt="send a message" /></a>
      
        <Header />
        <Cards />
        <Aboutus />
        <Testimonials />
      </div>
      <Footer />
    </>
  )
}

export default LandingPage
